import { render, staticRenderFns } from "./ReferralInfoModal.vue?vue&type=template&id=5847cce4&scoped=true"
import script from "./ReferralInfoModal.vue?vue&type=script&lang=js"
export * from "./ReferralInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralInfoModal.vue?vue&type=style&index=0&id=5847cce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847cce4",
  null
  
)

export default component.exports